module.exports = ".container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: calc(100% - 30px);\n  padding: 15px;\n  border-radius: 0 0 12px 12px; }\n  .container .branding-types-container {\n    -webkit-box-flex: 2;\n        -ms-flex: 2;\n            flex: 2; }\n  .container .scales-container {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/branding/branding/branding.component.scss
// module id = ./src/app/branding/branding/branding.component.scss
// module chunks = main